import { Drawer } from "@mui/material";
import {
  FullViewContainer,
  PlayerFromSamePositionContainer,
  SwapSimilarContainer,
  SwapSimulationContainer,
  TeamDrawerHeader,
  TeamFilterContainer,
  TeamSelectionContainer,
  TeamSelectionHeader,
} from "./StyledChemistryElements";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomIconButton from "../../ui/IconButton";
import {
  FormationData,
  IPlayerData,
  ITeamSearch,
  OtherSquadMembers,
  PlayerFromSamePositions,
  SubstitutePlayer,
} from "../../types/IOption";
import {
  ChemistryDetailsContainer,
  ForawrdBackwardButton,
  FormationPitchContainer,
} from "../../styled-components/PageHeaderStyles";
import { Theme } from "../../styles/Theme";
import EastIcon from "@mui/icons-material/East";
import SearchInput from "../../ui/SearchInput";
import SwapPlayerIcon from "../../assets/icons/SwapPlayer.png";
import { CurrentView } from "../../types/IPitchProps";
import CloseIcon from "@mui/icons-material/Close";
import { ReactNode, useState } from "react";
import ClubSearchList from "../../components/ClubLanding/ClubSearch/ClubSearchList";
import { IPlayerSearchResponse } from "../../types/IPlayerSearchResponse";
import { useTheme } from "../../contexts/ThemeContext";
import { InitialSearchPlayerList } from "../../styled-components/PlayerComponent.styles";
import PlayerSearchList from "../../components/PlayerLanding/PlayerSearch/PlayerSearchList";
import IApiResponse from "../../types/IApiResponse";
import {
  IArchetypeInfo,
  ITypicalPlayerExample,
  IWorksWellWith,
} from "../../components/PlayerLanding/PlayerSearch/PlayerSearchInit";
import { fetchData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import { getArchetypeColorByValue } from "../../utils/pitchWidgetUtils";
import { ModuleSpinner } from "../../ui/LoadingSpinner/ModuleSpinner";
import { useEffect } from "react";
import {
  archetypeCircleColors,
  ArchetypeComparisonChart,
  ColorBox,
  IComparisonData,
} from "./UIContentUtils";
import LabelText from "../../ui/LabelText";
import { ITeamArchtypeInfo } from "../../types/IClubDetail";
import { Label } from "@mui/icons-material";
import SecondaryButton from "../../ui/SecondaryButton";

interface TeamSelectProps {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  searchTerm: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleTeamClear: () => void;
  setOptionsShow: (value: React.SetStateAction<boolean>) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  handleInputKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  optionsShow: boolean;
  teams: ITeamSearch[];
  handleTeamChange: (team: string, teamId: string) => void;
}

export const TeamSelectDrawer: React.FC<TeamSelectProps> = ({
  sidebarOpen,
  setSidebarOpen,
  searchTerm,
  handleInputChange,
  handleTeamClear,
  setOptionsShow,
  inputRef,
  handleInputKeyDown,
  optionsShow,
  teams,
  handleTeamChange,
}) => {
  const { theme } = useTheme();
  const [selectedItems, setSelectedItems] = useState<IPlayerSearchResponse[]>(
    []
  );
  const [active, setActive] = useState<boolean>(false);
  const handleSelect = (
    item: IPlayerSearchResponse | IPlayerSearchResponse[] | null,
    selected: boolean
  ) => {};
  const renderSearchClubs = () => {
    return (
      teams &&
      teams?.length > 0 && (
        <div className="player-profile-list">
          <ClubSearchList
            searchData={teams}
            searchText={searchTerm}
            onSelect={handleSelect}
            selectedItems={selectedItems}
            multiSelection={false} //isAdding
            iconType="image"
            displayCheckBox={false}
            handleTeamChange={handleTeamChange}
            isMaxWidth={false}
          />
        </div>
      )
    );
  };
  return (
    <Drawer
      PaperProps={{
        style: {
          left: "70px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
          width: "500px",
        },
      }}
      anchor="left"
      variant="persistent"
      open={sidebarOpen}
      onClose={() => {
        setSidebarOpen(!sidebarOpen);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>Select Team</TeamDrawerHeader>
          {/* <CustomIconButton onClick={() => setSidebarOpen(false)}>
            <HighlightOffIcon />
          </CustomIconButton> */}
          <div className="header-buttons">
            <ForawrdBackwardButton onClick={() => setSidebarOpen(false)}>
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>
        <TeamFilterContainer>
          <div className="player-search-data">
            <div
              className={`container ${active ? "active" : "dormant"}`}
              style={{ borderColor: `${active ? theme.NumberColor : ""}` }}
            >
              <SearchInput
                handleSearch={handleInputChange}
                handleClear={handleTeamClear}
                placeholder="Search teams"
                fontSize="32px"
                type="SearchPlayer"
                clearInput={false}
                autoFocus={false}
                setIsFocus={setActive}
              />
            </div>
          </div>
          {searchTerm.length > 0 && renderSearchClubs()}
        </TeamFilterContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface FormationSelectProps {
  sidebarFormationOpen: boolean;
  setSidebarFormationOpen: (value: React.SetStateAction<boolean>) => void;
  formationData: FormationData[];
  theme?: Theme;
  selectedFormation: number;
  setSelectedFormation:
    | React.Dispatch<React.SetStateAction<number>>
    | ((formationId: number) => void);
  handleFormationChange?: (formationId: number) => void;
}

export const FormationSelectDrawer: React.FC<FormationSelectProps> = ({
  sidebarFormationOpen,
  setSidebarFormationOpen,
  formationData,
  theme,
  selectedFormation,
  setSelectedFormation,
  handleFormationChange,
}) => {
  return (
    <Drawer
      PaperProps={{
        style: {
          left: "70px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
          width: "100%",
          overflowY: "hidden",
        },
      }}
      anchor="left"
      variant="persistent"
      open={sidebarFormationOpen}
      onClose={() => {
        setSidebarFormationOpen(!sidebarFormationOpen);
      }}
    >
      <TeamSelectionContainer style={{ width: "420px" }}>
        <TeamSelectionHeader>
          <TeamDrawerHeader>Select Formation</TeamDrawerHeader>
          <div className="header-buttons">
            <ForawrdBackwardButton
              onClick={() => setSidebarFormationOpen(false)}
            >
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>
        <FormationPitchContainer>
          {formationData.map((formation, i) => (
            <div>
              <img
                src={`/assets/formations/${
                  theme?.PitchColor === "#1B1B1B" ? "dark" : "light"
                }/${formation?.formation || ""}.png`}
                alt={formation.formation}
                style={{
                  border:
                    formation.id === selectedFormation
                      ? "2px solid #00D1A8"
                      : "none",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSidebarFormationOpen(false);
                  handleFormationChange?.(formation.id);
                  setSelectedFormation(formation.id);
                }}
              />
              <div>
                <p>{formation.formation}</p>
                <p>USAGE: {formation.usagePercentage}%</p>
              </div>
            </div>
          ))}
        </FormationPitchContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface PlayerSelectProps {
  sidebarPlayerShow: boolean;
  setSidebarPlayerShow: (value: React.SetStateAction<boolean>) => void;
  isReplacePlayer: boolean;
  setIsReplacePlayer: (value: React.SetStateAction<boolean>) => void;
  playerFromSamePositions: PlayerFromSamePositions[];
  substitutePlayerOptions: SubstitutePlayer[];
  handleSwapPlayer: (playerToSwapWith: number) => void;
  otherSquadMembers: OtherSquadMembers[];
  currentView: CurrentView;
  handleSearchChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleClear: () => void;
  searchText: string;
  searchData: IPlayerSearchResponse[] | undefined;
  handleSelect: (
    item: IPlayerSearchResponse | IPlayerSearchResponse[] | null,
    selected: boolean
  ) => void;
  theme?: Theme;
}

export const PlayerSelectDrawer: React.FC<PlayerSelectProps> = ({
  sidebarPlayerShow,
  setSidebarPlayerShow,
  isReplacePlayer,
  setIsReplacePlayer,
  playerFromSamePositions,
  substitutePlayerOptions,
  handleSwapPlayer,
  otherSquadMembers,
  currentView,
  handleSearchChange,
  handleClear,
  searchText,
  searchData,
  handleSelect,
  theme,
}) => {
  const [active, setActive] = useState<boolean>(false);
  const renderSearchPlayers = () => {
    return (
      searchData?.length! > 0 && (
        <InitialSearchPlayerList className="search-player-list">
          <PlayerSearchList
            searchData={searchData!}
            searchText={searchText}
            onSelect={handleSelect}
            selectedItems={[]}
            multiSelection={false}
            iconType="image"
            displayCheckBox={false}
            isMaxWidth={false}
            isForComparePlayerASrchtype={false}
          />
        </InitialSearchPlayerList>
      )
    );
  };
  return (
    <Drawer
      PaperProps={{
        sx: {
          left: "70px",
          backgroundColor: "transparent",
          height: "100vh",
          overflowX: "clip",
          overflowY: "auto",
          msOverflowStyle: "none",
          zIndex: "9999",
          width: {
            sm: "400px", // Width for small screens and up
            md: "440px", // Width for medium screens and up
            lg: "540px",
          },
        },
      }}
      anchor="left"
      variant="persistent"
      open={sidebarPlayerShow}
      onClose={() => {
        setSidebarPlayerShow(!sidebarPlayerShow);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>
            {isReplacePlayer ? "Add player " : "Swap in a player"}
          </TeamDrawerHeader>
          <div className="header-buttons">
            <ForawrdBackwardButton
              onClick={() => {
                setSidebarPlayerShow(false);
                setIsReplacePlayer(false);
              }}
            >
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>
        <TeamFilterContainer className="custom-scrollbar">
          {currentView === "systemFit" && (
            <SwapSimilarContainer>
              <h5>Players from other teams</h5>
              <p className="otherSquad">
                Pick any other player to simulate their predicted chemistry
              </p>
              <div className="player-search-data">
                <div
                  className={`container ${active ? "active" : "dormant"}`}
                  style={{ borderColor: `${active ? theme?.NumberColor : ""}` }}
                >
                  <SearchInput
                    handleSearch={handleSearchChange}
                    handleClear={handleClear}
                    placeholder="Search players"
                    fontSize="32px"
                    type="SearchPlayer"
                    clearInput={false}
                    autoFocus={false}
                    setIsFocus={setActive}
                  />
                </div>
              </div>
              <div className="search-player-container">
                {searchText.length > 0 && renderSearchPlayers()}
              </div>
            </SwapSimilarContainer>
          )}

          {currentView === "systemFit" &&
            playerFromSamePositions?.length > 0 && (
              <SwapSimilarContainer>
                <h5>Also played in this position</h5>
                <PlayerFromSamePositionContainer className="custom-scrollbar">
                  {currentView === "systemFit" &&
                    playerFromSamePositions?.map((player) => (
                      <li key={player.playerId}>
                        <div>
                          <img
                            src={player.playerImageURL}
                            alt={player.shortName}
                          />
                          <p className="playerName">{player.shortName}</p>
                        </div>
                        <div>
                          <p className="minsPlayed">
                            {player.totalMinsPlayed} MIN PLAYED
                          </p>
                          <div
                            onClick={() => {
                              handleSwapPlayer(player.playerId);
                            }}
                          >
                            <EastIcon />
                          </div>
                        </div>
                      </li>
                    ))}
                </PlayerFromSamePositionContainer>
              </SwapSimilarContainer>
            )}
          {currentView === "passingNetwork" &&
            substitutePlayerOptions?.length > 0 && (
              <SwapSimilarContainer>
                <h5>Also played in this position</h5>
                <PlayerFromSamePositionContainer className="custom-scrollbar">
                  {currentView === "passingNetwork" &&
                    substitutePlayerOptions?.map((player) => (
                      <li key={player.playerId}>
                        <div>
                          <img
                            src={player.playerImageUrl}
                            alt={player.playerName}
                          />
                          <p className="playerName">{player.playerName}</p>
                        </div>
                        <div>
                          <p className="minsPlayed">
                            {player.substitutionDetail}
                          </p>
                          <div
                            onClick={() => {
                              handleSwapPlayer(player.playerId);
                            }}
                          >
                            <EastIcon />
                          </div>
                        </div>
                      </li>
                    ))}
                </PlayerFromSamePositionContainer>
              </SwapSimilarContainer>
            )}
          {currentView === "systemFit" && otherSquadMembers?.length > 0 && (
            <SwapSimulationContainer>
              <h5>Other squad members</h5>
              <PlayerFromSamePositionContainer className="custom-scrollbar">
                {otherSquadMembers?.map((player) => (
                  <li>
                    <div style={{ marginLeft: "10px" }}>
                      <p className="playerName">{player.shortName}</p>
                    </div>
                    <div>
                      <p className="minsPlayed">{player.positionCode}</p>
                      <div
                        onClick={() => {
                          handleSwapPlayer(player.playerId);
                        }}
                      >
                        <EastIcon />
                      </div>
                    </div>
                  </li>
                ))}
              </PlayerFromSamePositionContainer>
            </SwapSimulationContainer>
          )}
        </TeamFilterContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface PlayerSearchProps {
  playerDBSearch: boolean;
  setPlayerDBSearch: (value: React.SetStateAction<boolean>) => void;
  setIsReplacePlayer: (value: React.SetStateAction<boolean>) => void;
  handleSearchChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  searchText: string;
  handleClear: () => void;
  renderSearchPlayers: () => false | JSX.Element | undefined;
  theme?: Theme;
}

export const PlayerSearch: React.FC<PlayerSearchProps> = ({
  playerDBSearch,
  setPlayerDBSearch,
  setIsReplacePlayer,
  theme,
  handleSearchChange,
  searchText,
  handleClear,
  renderSearchPlayers,
}) => {
  const [active, setActive] = useState<boolean>(false);
  return (
    <Drawer
      PaperProps={{
        sx: {
          left: {
            sm: "460px", // Width for small screens and up
            md: "500px", // Width for medium screens and up
            lg: "580px",
          },
          backgroundColor: "transparent",
          overflow: "scroll",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          zIndex: "9",
          width: {
            sm: "345px", // Width for small screens and up
            md: "500px", // Width for medium screens and up
            lg: "600px",
          },
        },
      }}
      anchor="left"
      variant="persistent"
      open={playerDBSearch}
      onClose={() => {
        setPlayerDBSearch(!playerDBSearch);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>Player search</TeamDrawerHeader>
          <CustomIconButton
            onClick={() => {
              setPlayerDBSearch(false);
              setIsReplacePlayer(false);
            }}
          >
            <HighlightOffIcon />
          </CustomIconButton>
        </TeamSelectionHeader>
        <TeamFilterContainer>
          <div className="player-search-data">
            <div
              className={`container ${active ? "active" : "dormant"}`}
              style={{ borderColor: `${active ? theme?.NumberColor : ""}` }}
            >
              <SearchInput
                handleSearch={handleSearchChange}
                handleClear={handleClear}
                placeholder="Search players"
                fontSize="32px"
                type="SearchPlayer"
                clearInput={false}
                autoFocus={false}
                setIsFocus={setActive}
              />
            </div>
          </div>
          {searchText.length > 0 && renderSearchPlayers()}
        </TeamFilterContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface ChemistryInfoProps {
  informationShow: boolean;
  setInformationShow: (value: React.SetStateAction<boolean>) => void;
}

export const ChemistryInfo: React.FC<ChemistryInfoProps> = ({
  informationShow,
  setInformationShow,
}) => {
  return (
    <Drawer
      PaperProps={{
        style: {
          left: "356px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
        },
      }}
      anchor="left"
      variant="persistent"
      open={informationShow}
      onClose={() => {
        setInformationShow(!informationShow);
      }}
    >
      <TeamSelectionContainer
        style={{ maxWidth: "600px" }}
        className="chemistry-net-main"
      >
        <TeamSelectionHeader style={{ borderBottom: "0" }}>
          <TeamDrawerHeader>System Fit</TeamDrawerHeader>
          <CustomIconButton onClick={() => setInformationShow(false)}>
            <HighlightOffIcon />
          </CustomIconButton>
        </TeamSelectionHeader>
        <ChemistryDetailsContainer>
          <div>
            <h5>Overview</h5>
            <p>
              System fit scores represent how well two players play together.
              They can also be used to predict how well any two players could
              player together.
            </p>
          </div>
          <h5>How to work it</h5>
          <h6>Team view vs player view</h6>
          <p style={{ marginBlockStart: "0" }}>
            We pick the formation with the most heavily featured players and
            show all meaningful partnerships within it by default.
            <b> Click on a player</b> to see how well they interact with
            everyone on the pitch.
          </p>
          <h6>Swap in players</h6>
          <div
            style={{
              marginTop: "0",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <p style={{ marginBlockStart: "0", marginBlockEnd: "0" }}>
              Hover over a player and tap on their swap out button:
            </p>
            <img src={SwapPlayerIcon} alt="swap icon" />
          </div>
          <p>You can then replace them with any player in our system</p>
          <p>
            If you swap in a player who&apos;s never played enough minutes in
            that position within the specified timeframe, they&apos;ll be given
            a predicted score. These predicted scores are given a dotted line to
            mark them out from actual scores.
          </p>
          <h5>Connecting Lines</h5>
          <p>
            The number on connections represents the success score of the
            connection between players.
          </p>
          <p>Colours give a rough indication of success:</p>
          <div className="levelContainer">
            <span style={{ backgroundColor: "#4AF075" }}></span>
            <p>Highly successful</p>
          </div>
          <div className="levelContainer">
            <span style={{ backgroundColor: "#F2E94E" }}></span>
            <p>Somewhat successful</p>
          </div>
          <div className="levelContainer">
            <span style={{ backgroundColor: "#FF7800" }}></span>
            <p>Less successful</p>
          </div>
          <div className="levelContainer">
            <span style={{ backgroundColor: "#FF3864" }}></span>
            <p>Mostly successful</p>
          </div>
        </ChemistryDetailsContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface SelectPlayerPassingAttackDrawerProps {
  playerPassingAttackDrawerOpen: boolean;
  setPlayerPassingAttackDrawerOpen: (
    value: React.SetStateAction<boolean>
  ) => void;
  playerData: IPlayerData[];
  theme: Theme;
  passingAttackPlayerId: number;
  setPassingAttackPlayerId:
    | React.Dispatch<React.SetStateAction<number>>
    | ((playerId: number) => void);
  onConfirm: (playerId: number) => void;
}

export const SelectPlayerPassingAttackDrawer: React.FC<
  SelectPlayerPassingAttackDrawerProps
> = ({
  playerPassingAttackDrawerOpen,
  setPlayerPassingAttackDrawerOpen,
  playerData,
  setPassingAttackPlayerId,
  passingAttackPlayerId,
  onConfirm,
}) => {
  return (
    <Drawer
      PaperProps={{
        sx: {
          left: "70px",
          backgroundColor: "transparent",
          height: "100vh",
          // width: "520px",
          overflowX: "clip",
          overflowY: "auto",
          msOverflowStyle: "none",
          zIndex: "2",
          width: {
            sm: "400px", // Width for small screens and up
            md: "440px", // Width for medium screens and up
            lg: "520px",
          },
        },
      }}
      anchor="left"
      variant="persistent"
      open={playerPassingAttackDrawerOpen}
      onClose={() => {
        setPlayerPassingAttackDrawerOpen(!playerPassingAttackDrawerOpen);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>{"Select player"}</TeamDrawerHeader>
          <CustomIconButton
            onClick={() => {
              setPlayerPassingAttackDrawerOpen(false);
            }}
          >
            <HighlightOffIcon />
          </CustomIconButton>
        </TeamSelectionHeader>
        <TeamFilterContainer>
          <SwapSimilarContainer>
            <PlayerFromSamePositionContainer className="player-data-wrapper">
              {playerData.map((player) => (
                <li
                  key={player.value}
                  className={`player-data ${
                    passingAttackPlayerId === player.value ? "selected" : ""
                  }`}
                  onClick={() => {
                    setPassingAttackPlayerId(player.value);
                    onConfirm(player.value);
                    setPlayerPassingAttackDrawerOpen(false);
                  }}
                >
                  <div>
                    <img src={player.imageUrl} alt={player.label} />
                    <p className="playerName">{player.label}</p>
                  </div>
                </li>
              ))}
            </PlayerFromSamePositionContainer>
          </SwapSimilarContainer>
        </TeamFilterContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface FullModuleFitViewhProps {
  theme: Theme;
  isFullViewOpen: boolean;
  setIsFullViewOpen: React.Dispatch<React.SetStateAction<boolean>>;
  header: string;
  children: ReactNode;
}

export const FullModuleFitView: React.FC<FullModuleFitViewhProps> = ({
  theme,
  isFullViewOpen,
  setIsFullViewOpen,
  header,
  children,
}) => {
  return (
    <Drawer
      PaperProps={{
        sx: {
          left: {
            sm: "72px", // Width for small screens and up
            md: "72px", // Width for medium screens and up
            lg: "72px",
          },
          backgroundColor: "transparent",
          overflow: "scroll",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          zIndex: "999999",
          width: {
            sm: "97.5%", // Width for small screens and up
            md: "97.5%", // Width for medium screens and up
            lg: "97.5%",
          },
        },
      }}
      anchor="top"
      variant="persistent"
      open={isFullViewOpen}
      onClose={() => {
        setIsFullViewOpen(!isFullViewOpen);
      }}
    >
      <TeamSelectionContainer
        className="pop-pitch"
        style={{
          padding: "0",
          background: "transparent",
          backdropFilter: "blur(16px)",
        }}
      >
        <TeamSelectionHeader
          style={{
            padding: "25px 64px",
            backgroundColor: theme.playerContentBackground,
          }}
        >
          <TeamDrawerHeader>{header}</TeamDrawerHeader>
          <ForawrdBackwardButton onClick={() => setIsFullViewOpen(false)}>
            <CloseIcon className="cta-btn-icons" />
          </ForawrdBackwardButton>
        </TeamSelectionHeader>
        <FullViewContainer>{isFullViewOpen && children}</FullViewContainer>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface ArchetypeInfoProps {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  archetypeName: string;
  activeArchetypeID: number;
  playerPosition?: string;
}

export const ArchetypeInfoDrawer: React.FC<ArchetypeInfoProps> = ({
  sidebarOpen,
  setSidebarOpen,
  archetypeName,
  activeArchetypeID,
  playerPosition,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [worksWellWith, setWorksWellWith] = useState<IWorksWellWith[]>([]);
  const [typicalPlayerExamples, setTypicalPlayerExamples] = useState<
    ITypicalPlayerExample[]
  >([]);
  const [playerPScore, setPlayerPScore] = useState<IComparisonData>({});
  const [playerRaw, setPlayerRaw] = useState<IComparisonData>({});
  const [footprints, setFootPrints] = useState<IWorksWellWith[]>([]);
  const [activeComparisonArchetype, setActiveComparisonArchetype] = useState<
    number | null
  >(null);

  useEffect(() => {
    const fetchArchetypeInfoData = async () => {
      try {
        setLoading(true);
        const response: IApiResponse<IArchetypeInfo> = await fetchData(
          `${apiUrls["GetArchetypeDetails"]}/${activeArchetypeID}`
        );
        if (response.isSuccess) {
          setLoading(false);
          setWorksWellWith(response?.data?.worksWells);
          setActiveComparisonArchetype(
            response?.data?.footPrints?.[0]?.archetypeId
          );
          setTypicalPlayerExamples(response?.data?.typicals);
          setPlayerPScore(response?.data?.selectedPscore);
          setPlayerRaw(response?.data?.selectedRaw);
          setFootPrints(response?.data?.footPrints);
          return response;
        }
      } catch (error) {
        setLoading(false);
        return console.log(
          "500",
          "API call failed due to an internal server error"
        );
      }
    };
    if (sidebarOpen && activeArchetypeID) {
      fetchArchetypeInfoData();
    }
  }, [sidebarOpen , activeArchetypeID]);

  // useEffect(() => {
  //   if (activeArchetypeID > 0) {
  //     setWorksWellWith([]);
  //     setFootPrints([]);
  //     setTypicalPlayerExamples([]);
  //     setPlayerPScore({});
  //   }
  // }, [activeArchetypeID]);

  return (
    <Drawer
      PaperProps={{
        style: {
          left: "70px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
          width: "600px",
          zIndex: "99999",
        },
      }}
      anchor="left"
      variant="persistent"
      open={sidebarOpen}
      onClose={() => {
        setSidebarOpen(!sidebarOpen);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>{archetypeName}</TeamDrawerHeader>
          <div className="header-buttons">
            <ForawrdBackwardButton
              onClick={(event) => {
                event?.stopPropagation();
                document
                  .querySelectorAll(".squad-pitch-player-card")
                  ?.forEach((card) => {
                    (card as HTMLElement).style.zIndex = "0";
                  });
                setSidebarOpen(false);
              }}
            >
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>

        <div
          style={{
            borderTop: "1px solid var(--Warm-Grey-warm-grey-300, #DADADA)",
          }}
        >
          {/* -----------------Dynamic 7 Start-------------------- */}
          {activeArchetypeID === 1 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      This is a high-volume creator and box threat.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Best progressive playmaker.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Great in transition and press (high recoveries,
                      counterpressing).
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Dynamic 7 End-------------------- */}
          {/* -----------------Direct 7 Start-------------------- */}
          {activeArchetypeID === 2 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A classic winger profile with speed and runs into the box,
                      but less creative in build-up or pressing involvement.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      A vertical runner, suited to direct counterattacks or
                      systems that isolate wingers 1v1 to run at defenders.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Direct 7 End-------------------- */}
          {/* -----------------Balanced 7 Start-------------------- */}
          {activeArchetypeID === 3 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A classic pace-and-space winger — thrives when facing
                      goal.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      An active wide presence with high accelerations and decent
                      pressing metrics.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 7 End-------------------- */}
          {/* -----------------Incisive 7 Start-------------------- */}
          {activeArchetypeID === 4 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Ideal for systems needing wide ball progressors who can
                      both initiate and finish plays.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Wide creator in teams that use inverted full backs and
                      demand wide overloads.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Incisive 7 End-------------------- */}
          {/* -----------------Balanced 10 Start-------------------- */}
          {activeArchetypeID === 5 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>High-energy</b> attacking
                      mids who contribute across buildup, pressing, and
                      shooting.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Ideal in high-intensity systems — a well-rounded player
                      who can defend from the front and contribute creatively.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 10 End-------------------- */}
          {/* -----------------Dynamic 10 Start-------------------- */}
          {activeArchetypeID === 6 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Useful in deeper playmaking triangles; excels in keeping
                      possession without taking creative risks.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low-risk, low-output midfielders who keep play ticking but
                      don’t break lines or defend aggressively.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Dynamic 10 End-------------------- */}
          {/* -----------------Box Crashing 10 Start-------------------- */}
          {activeArchetypeID === 7 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Suited for direct or transition-heavy teams that benefit
                      from an attacking midfielder as an auxiliary goal threat
                      or late runner.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Box Crashing 10 End-------------------- */}
          {/* -----------------Creative 10 Start-------------------- */}
          {activeArchetypeID === 8 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Ideal in central overload systems, positional play setups,
                      or any team that rely on an attacking midfield fielder to
                      carry creative and transitional burden.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Creative 10 End-------------------- */}
          {/* -----------------Enforcing 4 Start-------------------- */}
          {activeArchetypeID === 9 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Dominant in defensive duels and clearances, less mobile
                      and rarely involved in buildup—this is a safety-first
                      central defender suits low block systems.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Enforcing 4 End-------------------- */}
          {/* -----------------Balanced 4 Start-------------------- */}
          {activeArchetypeID === 10 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Less of a traditional stopper, more of a modern "step-out"
                      defender. Reliable in multiple systems, adaptable, but may
                      lack elite specialization.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 4 End-------------------- */}
          {/* -----------------Tenacious 4 Start-------------------- */}
          {activeArchetypeID === 11 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A hybrid centre-back who performs moderately across most
                      metrics—combines decent defensive contributions with
                      reasonable mobility.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Complements aggressive partners or fits into systems with
                      zonal defending and structured backlines.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Tenacious 4 End-------------------- */}
          {/* -----------------Complete 4 Start-------------------- */}
          {activeArchetypeID === 12 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>Built for possession-oriented teams.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Most mobile and technical, strong on the ball and in
                      transitions, but lower in traditional defensive actions
                      like clearances or aerials.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Can initiate play and defend capably—could work in either
                      a back 3 or back 4.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Complete 4 End-------------------- */}
          {/* -----------------Expansive 9 Start-------------------- */}
          {activeArchetypeID === 13 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A well-rounded striker who scores, links play, and
                      contributes to pressing.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Effective both in and outside the box.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Expansive 9 End-------------------- */}
          {/* -----------------Target 9 Start-------------------- */}
          {activeArchetypeID === 14 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A rare striker who leads the line with strength, hold-up
                      play, and aerial presence, while actively contributing to
                      defensive transitions through counterpressing.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Target 9 End-------------------- */}
          {/* -----------------Direct 9 Start-------------------- */}
          {activeArchetypeID === 15 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A pure finisher who thrives on service—relies on movement,
                      anticipation, and positioning over build-up involvement.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Direct 9 End-------------------- */}
          {/* -----------------Balanced 9 Start-------------------- */}
          {activeArchetypeID === 16 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A mobile, high-energy striker who contributes with
                      pressing and movement more than goal volume.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 9 End-------------------- */}
          {/* -----------------Metronomic 8 Start-------------------- */}
          {activeArchetypeID === 17 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Keeps play ticking with safe distribution and moderate
                      positional discipline.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      More about ball retention than progression or pressing
                      involvement.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Solid in possession retention roles.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Metronomic 8 End-------------------- */}
          {/* -----------------Hybrid 8 Start-------------------- */}
          {activeArchetypeID === 18 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A well-rounded midfielder with good balance between ball
                      progression and defensive work.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Ideal for transitional midfields — a system-reliable
                      all-rounder who supports both phases without being the
                      focal point
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Hybrid 8 End-------------------- */}
          {/* -----------------Box-to-box 8 Start-------------------- */}
          {activeArchetypeID === 19 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Highly active in aerial duels and ground coverage, this
                      midfielder is built for disruption and box-to-box work
                      rather than elegance.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Box-to-box 8 End-------------------- */}
          {/* -----------------High-Tempo 8 Start-------------------- */}
          {activeArchetypeID === 20 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      High accelerations and forward movement paired with
                      attacking width—provides final-third presence and
                      transitions rapidly.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Excellent as an advanced 8 in a 4-3-3.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------High-Tempo 8 End-------------------- */}
          {/* -----------------Anchoring 6 Start-------------------- */}
          {activeArchetypeID === 21 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Strong aerial presence and defensive solidity, but lacks
                      technical mobility—stays deep, breaks up play, and clears
                      danger.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Best used in low block systems where physical presence and
                      protection matter most.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Anchoring 6 End-------------------- */}
          {/* -----------------Playmaking 6 Start-------------------- */}
          {activeArchetypeID === 22 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      A dynamic creator from deep— technically strong, mobile,
                      and involved in{" "}
                      <b style={{ color: "black" }}>buildup and attack</b>— but{" "}
                      <b style={{ color: "black" }}>
                        less involved defensively
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Playmaking 6 End-------------------- */}
          {/* -----------------Disruptive 6 Start-------------------- */}
          {activeArchetypeID === 23 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      All-rounder - Connector rather than a specialist.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Helps in defensive shape, and makes occasional attacking
                      runs but doesn’t carry or break lines much.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Disruptive 6 End-------------------- */}
          {/* -----------------Balanced 6 Start-------------------- */}
          {activeArchetypeID === 24 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Balances mobility with moderate pressing and attacking
                      contribution.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Great in{" "}
                      <b style={{ color: "black" }}>off-ball pressing</b> or
                      counterpress setups.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Useful in teams that want a bit of everything without
                      overcommitting to risk.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 6 End-------------------- */}
          {/* -----------------Balanced 2 Start-------------------- */}
          {activeArchetypeID === 25 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Ideal for teams needing defensive solidity from wide
                      areas, especially in aerial-heavy or low-block systems.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 2 End-------------------- */}
          {/* -----------------Specialist 2 Start-------------------- */}
          {activeArchetypeID === 26 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Slightly above average in clearances and aerials, average
                      everywhere else—a jack-of-all-trades profile with moderate
                      involvement.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Specialist 2 End-------------------- */}
          {/* -----------------Playmaking 2 Start-------------------- */}
          {activeArchetypeID === 27 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Best suited for wing-back roles in back three systems or
                      high-possession sides with CB cover.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Exceptional in
                      <b style={{ color: "black" }}>crossing</b> and{" "}
                      <b style={{ color: "black" }}>attack</b> but poor in duels
                      and aerials—think{" "}
                      <b style={{ color: "black" }}>wing-back</b> or{" "}
                      <b style={{ color: "black" }}>attacking full-back</b>{" "}
                      archetype.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Playmaking 2 End-------------------- */}
          {/* -----------------Combative 2 Start-------------------- */}
          {activeArchetypeID === 28 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">
                  Characteristics:
                </LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Great for deep blocks in a back four who can handle 1v1
                      defending.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      High output in duels and clearances, with strong
                      acceleration.{" "}
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Prefers to break up play and recover balls rather than
                      contribute in advanced areas.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Combative 2 End-------------------- */}
        </div>

        <div className="individuas-pitch-player-conatiner">
          <div className="typical-exmaples-container">
            <p>Typical examples</p>
            <div className="individual-typical-player-container">
              {typicalPlayerExamples?.map((example) => (
                <div className="individual-typical-player">
                  <img src={example?.imageUrl} alt="player-image" />
                  <div>
                    <p className="typical-player-name">{example?.shortName}</p>
                    <p className="typical-player-club">{example?.teamName}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="typical-heat-signature-container">
            <p>Works well with...</p>
            <div>
              {worksWellWith?.map((work) => (
                <div
                  style={{
                    backgroundColor: getArchetypeColorByValue(work?.score),
                  }}
                  className="work-archetype"
                >
                  {work?.archetypeName}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          style={{
            borderBottom: "1px solid var(--Warm-Grey-warm-grey-300, #DADADA)",
          }}
        >
          <p className="role-comparison-header">
            Compared to other {playerPosition} roles
          </p>
          <div className="archetype-chart-container">
            <ArchetypeComparisonChart
              data={playerPScore || {}}
              rawData={playerRaw || {}}
              comparisonData={
                footprints?.find(
                  (segment) =>
                    segment?.archetypeId === activeComparisonArchetype
                )?.footprintPscore!
              }
              width={250}
              height={250}
            />
            <div className="side-container-comparison-archetype">
              {worksWellWith?.length > 0 && (
                <div className="archetype-selected-segement">
                  <ColorBox color={archetypeCircleColors[0]} />
                  <div className="archetype-selected-segement-text">
                    {archetypeName}
                  </div>
                </div>
              )}
              {footprints?.map((archetype) => (
                <div
                  key={archetype.archetypeId}
                  className="archetype-radio-item"
                  onClick={(event) => {
                    event?.stopPropagation();
                    setActiveComparisonArchetype(
                      activeComparisonArchetype === archetype.archetypeId
                        ? null
                        : archetype.archetypeId
                    );
                  }}
                >
                  <input
                    type="radio"
                    id={`archetype-${archetype.archetypeId}`}
                    name="archetype-comparison"
                    checked={
                      activeComparisonArchetype === archetype.archetypeId
                    }
                  />
                  <label htmlFor={`archetype-${archetype.archetypeId}`}>
                    {archetype.archetypeName}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="archetype-segement-container">
            {Object.entries(playerPScore)
              .filter(([_, value]) => value !== null)
              .map(([key, _], index) => (
                <div key={key} className="archetype-segment-item">
                  <ColorBox
                    color={
                      archetypeCircleColors[
                        index % archetypeCircleColors.length
                      ]
                    }
                  />
                  <div className="archetype-segement-text">
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .trim()
                      .toUpperCase()}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div
          style={{
            borderTop: "1px solid var(--Warm-Grey-warm-grey-300, #DADADA)",
          }}
        >
          {/* -----------------Dynamic 7 Start-------------------- */}
          {activeArchetypeID === 1 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Strong in <b style={{ color: "black" }}>box touches </b>
                      and <b style={{ color: "black" }}>shot volume.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Elite in through passes, accelerations, and recoveries.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Limited aerial presence (duels, headed shots) and Lower
                      defensive output in duels.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Dynamic 7 End-------------------- */}
          {/* -----------------Direct 7 Start-------------------- */}
          {activeArchetypeID === 2 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Makes smart box runs{" "}
                      <b style={{ color: "black" }}>(high touches in box)</b>
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Poor contribution to pressing and recovery.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low playmaking{" "}
                      <b style={{ color: "black" }}>
                        (low through passes, counterpressing).
                      </b>
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Direct 7 End-------------------- */}
          {/* -----------------Balanced 7 Start-------------------- */}
          {activeArchetypeID === 3 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Touch in Box: Gets into scoring areas.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Shots: Finishing-oriented profile, takes attempts when in
                      position.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Below average crosses and touches in the box.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 7 End-------------------- */}
          {/* -----------------Incisive 7 Start-------------------- */}
          {activeArchetypeID === 4 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Elite in recoveries, counterpressing, forward passes,{" "}
                      <b style={{ color: "black" }}>dribbling</b>, and{" "}
                      <b style={{ color: "black" }}>final-third play</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Limited aerial presence (duels, headed shots)
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Incisive 7 End-------------------- */}
          {/* -----------------Balanced 10 Start-------------------- */}
          {activeArchetypeID === 5 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Good passing volume and link-up support.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Balanced positioning — involved in the box and general
                      buildup.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Not a pressing</b> asset.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 10 End-------------------- */}
          {/* -----------------Dynamic 10 Start-------------------- */}
          {activeArchetypeID === 6 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Good forward passing,{" "}
                      <b style={{ color: "black" }}>accelerations</b>, shot
                      volume, and decent{" "}
                      <b style={{ color: "black" }}>dribbling</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Slightly lower involvement in elite creation metrics
                      (e.g., through passes, final third entries).
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Moderate touch in box and aerial contribution.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Dynamic 10 End-------------------- */}
          {/* -----------------Box Crashing 10 Start-------------------- */}
          {activeArchetypeID === 7 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Extremely{" "}
                      <b style={{ color: "black" }}>high in aerial duels</b> and{" "}
                      <b style={{ color: "black" }}>head shots</b>.
                    </LabelText>
                  </li>

                  <li>
                    <LabelText>
                      Very strong touches in the box — indicative of a
                      second-striker or late box-arrival role.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Very low on dribbles, forward passing, through passes,
                      accelerations, crosses, and overall playmaking.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Poor counterpressing activity and progression
                      contribution.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Box Crashing 10 End-------------------- */}
          {/* -----------------Creative 10 Start-------------------- */}
          {activeArchetypeID === 8 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Excellent forward passes</b>
                      , passes to final third, through balls, crosses, link-up
                      play, and dribbles.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      High accelerations and counterpressing recoveries{" "}
                      <b style={{ color: "black" }}>
                        — active on and off the ball
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Weak aerial presence</b> and
                      limited box involvement.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Creative 10 End-------------------- */}
          {/* -----------------Enforcing 4 Start-------------------- */}
          {activeArchetypeID === 9 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>Top in clearances and dual rates.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Effective in penalty box defending and counter pressing.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Limited value in progressive play: low total passes.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Minimal involvement in offensive duels and accelerations.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Enforcing 4 End-------------------- */}
          {/* -----------------Balanced 4 Start-------------------- */}
          {activeArchetypeID === 10 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>Solid mobility (high accelerations).</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Moderate dribble involvement and press resistance.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Below average in clearances and counterpressing.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Not dominant in duels or box defending.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 4 End-------------------- */}
          {/* -----------------Tenacious 4 Start-------------------- */}
          {activeArchetypeID === 11 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Good in defensive duels and clearances.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Balanced without extremes.</LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Not elite in any particular area.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Slightly underperforms in pressing or progressive metrics.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Tenacious 4 End-------------------- */}
          {/* -----------------Complete 4 Start-------------------- */}
          {activeArchetypeID === 12 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Top in accelerations and dribbles
                      </b>
                      .
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Offers press resistance.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Progression and high overall passing volume.
                      </b>
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Does less core defending: defensive duels, interceptions,
                      shot blocking, aerial duels.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Complete 4 End-------------------- */}
          {/* -----------------Expansive 9 Start-------------------- */}
          {activeArchetypeID === 13 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      High in{" "}
                      <b style={{ color: "black" }}>
                        touches in box, shots, xG,
                      </b>{" "}
                      and <b style={{ color: "black" }}>aerial duels</b>.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Strong <b style={{ color: "black" }}>link-up play</b> and{" "}
                      <b style={{ color: "black" }}>passes to final third</b>.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Positive in{" "}
                      <b style={{ color: "black" }}>counterpressing</b> and{" "}
                      <b style={{ color: "black" }}>accelerations</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Aerial Presence</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Expansive 9 End-------------------- */}
          {/* -----------------Target 9 Start-------------------- */}
          {activeArchetypeID === 14 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Aerial duels</b>,{" "}
                      <b style={{ color: "black" }}>head shots</b>,
                      interceptions, Counter pressing.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Dribbles, progressive passing.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Target 9 End-------------------- */}
          {/* -----------------Direct 9 Start-------------------- */}
          {activeArchetypeID === 15 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Very high average xg, off-ball runs
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Counter pressing.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Direct 9 End-------------------- */}
          {/* -----------------Balanced 9 Start-------------------- */}
          {activeArchetypeID === 16 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      High in{" "}
                      <b style={{ color: "black" }}>
                        touches in box, shots, xG, link-up play, dribbles and
                        accelerations
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Aerial Presence, Ball Recoveries
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 9 End-------------------- */}
          {/* -----------------Metronomic 8 Start-------------------- */}
          {activeArchetypeID === 17 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Balanced profile</b>, avoids
                      extremes, with good defensive contribution (recoveries,
                      interceptions).
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Lacks creativity: low forward passes, final third entries,
                      through passes.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low attacking threat and minimal verticality (touches in
                      box, shots, dribbles).
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Metronomic 8 End-------------------- */}
          {/* -----------------Hybrid 8 Start-------------------- */}
          {activeArchetypeID === 18 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Excellent in{" "}
                      <b style={{ color: "black" }}>counterpressing</b>{" "}
                      recoveries.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Average acceleration and involvement in transitions.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Lacks standout aerial presence. Lower touch in box and
                      goal threat.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Limited offensive aggression or crossing range.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Hybrid 8 End-------------------- */}
          {/* -----------------Box-to-box 8 Start-------------------- */}
          {activeArchetypeID === 19 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Strong aerial</b> duels and
                      touch in box.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Strong in physical metrics
                      </b>
                      .
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>High head shots and attacking intent.</LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Low in accelerations and pressing efficiency.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Very weak in buildup (lowest forward passes, final third
                      passes, through balls).
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Weak in technical play.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Box-to-box 8 End-------------------- */}
          {/* -----------------High-Tempo 8 Start-------------------- */}
          {activeArchetypeID === 20 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Top for accelerations</b>.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Great at crossing and offensive half involvement
                      </b>
                      .
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Low aerial and defensive contribution
                      </b>
                      .
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Not a ball-winner</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------High-Tempo 8 End-------------------- */}
          {/* -----------------Anchoring 6 Start-------------------- */}
          {activeArchetypeID === 21 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Excellent in{" "}
                      <b style={{ color: "black" }}>aerial duels</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Physical</b> profile fits
                      defensive protection roles.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Anchoring 6 End-------------------- */}
          {/* -----------------Playmaking 6 Start-------------------- */}
          {activeArchetypeID === 22 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Top acceleration and crossing
                      </b>
                      .
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Strong progressive metrics (passes, positioning).
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Less involved in direct defending or clearances
                      </b>
                      .
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Needs defensive coverage: either a mobile box-to-box
                      partner or an aggressive back line.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Playmaking 6 End-------------------- */}
          {/* -----------------Disruptive 6 Start-------------------- */}
          {activeArchetypeID === 23 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Solid scores in{" "}
                      <b style={{ color: "black" }}>counterpressing</b>,{" "}
                      <b style={{ color: "black" }}>box touches</b>, and overall
                      tempo management.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Below average in{" "}
                      <b style={{ color: "black" }}>ball progression</b> and{" "}
                      <b style={{ color: "black" }}>acceleration</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Doesn’t break lines or attack space.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Disruptive 6 End-------------------- */}
          {/* -----------------Balanced 6 Start-------------------- */}
          {activeArchetypeID === 24 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Strong in interceptions</b>{" "}
                      and <b style={{ color: "black" }}>counterpressing</b>;
                      decent passer.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Lacks ball-carrying and{" "}
                      <b style={{ color: "black" }}>box activity</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 6 End-------------------- */}
          {/* -----------------Balanced 2 Start-------------------- */}
          {activeArchetypeID === 25 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Excellent in aerial duels, clearances, defensive duels and
                      interceptions.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Solid long-passing ability and conservative distribution.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Not elite in any particular area.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Slightly underperform in pressing or progressive metrics.
                    </LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Balanced 2 End-------------------- */}
          {/* -----------------Specialist 2 Start-------------------- */}
          {activeArchetypeID === 26 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Reliable defender with minor attacking weaknesses.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Good in aerial challenges.</LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Not quick or creative in buildup.</LabelText>
                  </li>
                  <li>
                    <LabelText>No standout traits.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Specialist 2 End-------------------- */}
          {/* -----------------Playmaking 2 Start-------------------- */}
          {activeArchetypeID === 27 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>Dominates crossing volume.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Involved in{" "}
                      <b style={{ color: "black" }}>forward phases</b>.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Weak in clearances and aerial duels.</LabelText>
                  </li>
                  <li>
                    <LabelText>Not ideal for isolated 1v1 defending.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Playmaking 2 End-------------------- */}
          {/* -----------------Combative 2 Start-------------------- */}
          {activeArchetypeID === 28 && (
            <div className="team-archtype-info">
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Strengths:</LabelText>
                <ul>
                  <li>
                    <LabelText>
                      Best in defensive duels and clearances.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Solid acceleration to recover or press.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Physically reliable with aerial presence.
                    </LabelText>
                  </li>
                </ul>
              </div>
              <div className="team-archtype-info-content">
                <LabelText className="player-given-name">Weaknesses:</LabelText>
                <ul>
                  <li>
                    <LabelText>Poor crossing and attacking support.</LabelText>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {/* -----------------Combative 2 End-------------------- */}
        </div>
      </TeamSelectionContainer>
      {loading && <ModuleSpinner />}
    </Drawer>
  );
};

interface TeamArchetypeInfoProps {
  teamsidebarOpen: boolean;
  setTeamSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  archetypeName: string;
  activeArchetypeID: number;
}

export const TeamArchetypeInfoDrawer: React.FC<TeamArchetypeInfoProps> = ({
  teamsidebarOpen,
  setTeamSidebarOpen,
  archetypeName,
  activeArchetypeID,
}) => {

  const [strengh, setStrength] = useState<string>("");
  const [weakness, setWeakness] = useState<string>("");
  const [gameModelfit, setGameModelFit] = useState<string>("");
  const [tacticsFormation, setTackticsFormation] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [teamArchtypeInfo, setTeamArchTypeInfo] = useState<ITeamArchtypeInfo[]>(
    []
  );

  useEffect(() => {
    switch (activeArchetypeID) {
      case 1:
        setStrength(
          "Very high in defensive duels, offensive duels, and dribbles.\n High forward passes, interceptions, and passes to the final third."
        );
        setWeakness(
          "Slightly negative on touches in box and xG conceded, indicating some defensive vulnerabilities."
        );
        setGameModelFit(
          "Gegenpressing, Red Bull model, transitional football."
        );
        setTackticsFormation(
          "High pressing line, forced turnovers, vertical play."
        );
        break;

      case 2:
        setStrength(
          "Strong in xG conceded (defensive solidity), compactness.\n Moderate shots and through passes."
        );
        setWeakness(
          "Poor in almost all creative and possession metrics, including passes, crosses, and duels."
        );
        setGameModelFit(
          "Reactive/Counter-attacking, Simeone-style compactness."
        );
        setTackticsFormation(
          "Mid/low block. Emphasis on transitions and set pieces."
        );
        break;

      case 3:
        setStrength(
          "Outstanding in aerial duels, recoveries, and defensive duels.\n Decent attacking value in crosses, passes to final third, and offensive duels."
        );
        setWeakness(
          "Below-average xG from shots and touches in box - lack of goal threat."
        );
        setGameModelFit(
          "Defensive possession or Territorial dominance, like Conte's structured systems."
        );
        setTackticsFormation(
          "Strong midfield shielding. Set-piece reliance and direct wing play."
        );
        break;

      case 4:
        setStrength(
          "High xG, touches in box, shots, and crosses.\n Balanced metrics across the board, offensively tilted."
        );
        setWeakness("Slightly weak in recoveries and defensive duels.");
        setGameModelFit(
          "Possession-to-penetrate, positional play (e.g., Guardiola or Nagelsmann style)."
        );
        setTackticsFormation(
          "Overloads in half-spaces, high positional discipline."
        );
        break;

      case 5:
        setStrength(
          "High passes, pass length, and head shots. \nLow xG against, suggesting strong control of territory."
        );
        setWeakness(
          "Low crosses, dribbles, and recoveries - possession without penetration."
        );
        setGameModelFit(
          "Control and retention model, like Sarri-ball or classic Barcelona."
        );
        setTackticsFormation(
          "Requires technical midfielders and progressive CBs."
        );
        break;

      case 6:
        setStrength(
          "High fouls, defensive duels, and interceptions.\n Solid aerial presence and physical metrics."
        );
        setWeakness(
          "Poor final third entries, through passes, and xG creation.Low touches in box and crosses – limited attacking thrust."
        );
        setGameModelFit(
          "Midfield disruption and second-ball dominance, like vintage Moyes or Allardyce sides."
        );
        setTackticsFormation(
          "Emphasis on winning duels, disrupting rhythm, exploiting set pieces."
        );
        break;

      case 7:
        setStrength(
          "Moderately stable in xG against and head shots, suggesting compact shape.\n Balanced passing with average pass volume and defensive coverage."
        );
        setWeakness(
          "Low in pressing, duels, and chance creation. Very little penetration via through balls or touches in box."
        );
        setGameModelFit(
          "Conservative ball retention, similar to late-phase Mourinho teams."
        );
        setTackticsFormation(
          "Low-to-mid block structure with safety-first possession."
        );
        break;

      case 8:
        setStrength(
          "Elite in xG from shots, touches in box, crosses, and through balls.\n High shots, dribbles, and offensive duels – total attacking profile."
        );
        setWeakness(
          "Below average in defensive duels and recoveries - high-risk attacking team."
        );
        setGameModelFit(
          "Direct and vertical attack, like Klopp’s Liverpool or Atalanta under Gasperini."
        );
        setTackticsFormation(
          "Fast wide combinations, overlaps, and central overloads"
        );
        break;

      default:
        // Optional: handle unknown archetype IDs
        break;
    }

    const fetchArchetypeInfoData = async () => {
      try {
        setLoading(true);
        const response: IApiResponse<ITeamArchtypeInfo[]> = await fetchData(
          `${apiUrls["GetTeamArchetypeDetails"]}/${activeArchetypeID}`
        );
        if (response.isSuccess) {
          setLoading(false);
          setTeamArchTypeInfo(response.data);
          return response;
        }
      } catch (error) {
        setLoading(false);
        return console.log(
          "500",
          "API call failed due to an internal server error"
        );
      }
    };
    fetchArchetypeInfoData();
  }, [activeArchetypeID]);

  return (
    <Drawer
      PaperProps={{
        style: {
          left: "70px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
          width: "800px",
          zIndex: "99999",
        },
      }}
      anchor="left"
      variant="persistent"
      open={teamsidebarOpen}
      onClose={() => {
        setTeamSidebarOpen(!teamsidebarOpen);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader>{archetypeName}</TeamDrawerHeader>
          <div className="header-buttons">
            <ForawrdBackwardButton
              onClick={(event) => {
                event?.stopPropagation();
                document
                  .querySelectorAll(".squad-pitch-player-card")
                  ?.forEach((card) => {
                    (card as HTMLElement).style.zIndex = "0";
                  });
                setTeamSidebarOpen(false);
              }}
            >
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>
        {/* ------------------------------------- Start*/}
        {/* {activeArchetypeID === 1 && (
          <div className="team-archtype-info">
            <div className="team-archtype-info-content">
              <LabelText className="player-given-name">
                Game Model Fit:
              </LabelText>
              <ul>
                <li>
                  <LabelText>
                    <b style={{ color: "black" }}>Gegenpressing,</b> Red Bull
                    model, transitional football.
                  </LabelText>
                </li>
              </ul>
            </div>
            <div className="team-archtype-info-content">
              <LabelText className="player-given-name">Strengths:</LabelText>
              <ul>
                <li>
                  <LabelText>
                    High
                    <b style={{ color: "black" }}>
                      forward passes, Interceptions,
                    </b>
                    and{" "}
                    <b style={{ color: "black" }}>passes to the final third.</b>
                  </LabelText>
                </li>
                <li>
                  <LabelText>
                    <b style={{ color: "black" }}>
                      Elite defensive engagement:
                    </b>
                    Outstanding in defensive duels (+1.82) and high
                    interceptions (+1.31)
                  </LabelText>
                </li>
                <li>
                  <LabelText>
                    <b style={{ color: "black" }}>Physical attacking style:</b>
                    Very high in
                    <b style={{ color: "black" }}>
                      defensive duels, offensive duels
                    </b>
                    (+1.78), and <b style={{ color: "black" }}>dribbles</b>{" "}
                    (+1.43)
                  </LabelText>
                </li>
                <li>
                  <LabelText>
                    <b style={{ color: "black" }}>Active disruption:</b> High
                    fouling rate (+1.35) and good ball recoveries (+0.88)
                  </LabelText>
                </li>
                <li>
                  <LabelText>
                    <b style={{ color: "black" }}>Direct play tendencies:</b>
                    Good in forward passes (+0.55) and aerial duels (+0.51)
                  </LabelText>
                </li>
              </ul>
            </div>
            <div className="team-archtype-info-content">
              <LabelText className="player-given-name">Weaknesses:</LabelText>
              <ul>
                <li>
                  <LabelText>
                    Slightly negative on
                    <b style={{ color: "black" }}> touches in box</b>and
                    <b style={{ color: "black" }}>xG conceded,</b>
                    indicating some defensive vulnerabilities.
                  </LabelText>
                </li>
              </ul>
            </div>
            <div className="team-archtype-info-content">
              <LabelText className="player-given-name">Tactical:</LabelText>
              <ul>
                <li>
                  <LabelText>
                    {" "}
                    This team archetype excels at aggressive pressing and
                    winning the ball through physical confrontations all over
                    the pitch. They're disruptive, combative, and relentless in
                    challenging opponents, making them difficult to play
                    against. Their high involvement in both defensive and
                    offensive duels suggests they excel in transition moments
                    and can quickly turn defence into attack.
                  </LabelText>
                </li>
              </ul>
            </div>
          </div>
        )} */}
        {/* ------------------------------------- End*/}

        <div style={{ paddingTop: "20px" }}>
          <div className="team-archtype-info-content">
            <LabelText className="player-given-name">Game Model Fit:</LabelText>
            <ul>
              {activeArchetypeID === 3 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Defensive possession or Territorial dominance,
                      </b>{" "}
                      like Conte's structured systems.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 1 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Gegenpressing,</b> Red Bull
                      model, transitional football.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 8 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Distinct and coherent: This cluster is well-defined by
                        speed-oriented metrics, making it a clean separation in
                        the model space.
                      </b>{" "}
                      Its z-scores show consistent above-average performance in
                      transition traits and average-to-below in physical and
                      possession-heavy metrics.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Vertical Transition Team —
                      </b>{" "}
                      efficient, fast-moving, and reliant on burst acceleration
                      and passing lanes over intricate possession. Possibly
                      low-block teams with vertical threat.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 6 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Midfield disruption and second-ball dominance,
                      </b>{" "}
                      like vintage Moyes or Allardyce sides.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 4 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Possession-to-penetrate,</b>{" "}
                      positional play (e.g., Guardiola or Nagelsmann style).
                      <b style={{ color: "black" }}>
                        {" "}
                        Attacking powerhouse that creates numerous high-quality
                        chances through intricate passing combinations and
                        advanced technical ability.
                      </b>
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 2 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Reactive/Counter-attacking,
                      </b>{" "}
                      Simeone-style compactness.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Long Ball Specialist Team- A team built around winning
                        aerial battles and playing direct, long balls to bypass
                        midfield pressure, specializing in set pieces and
                        crosses.
                      </b>{" "}
                      This represents teams that play direct, long-ball football
                      and excel in the air.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 7 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Conservative ball retention,
                      </b>{" "}
                      similar to late-phase Mourinho teams.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 5 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Control and retention </b>
                      model, like Sarri-ball or classic Barcelona.
                    </LabelText>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="team-archtype-info-content">
            <LabelText className="player-given-name">Strengths:</LabelText>
            <ul>
              {activeArchetypeID === 3 && (
                <>
                  <li>
                    <LabelText>
                      This cluster represents teams that focus on a cautious,
                      defensive approach. They have:
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      The lowest number of crosses (-1.63 z-score) and shots
                      (-1.43)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Very few passes to the final third (-1.57) and forward
                      passes (-1.48)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Highest expected goals against (1.44), suggesting they
                      concede quality chances
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Below average in most offensive metrics (only 303.78
                      passes per game)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 1 && (
                <>
                  <li>
                    <LabelText>
                      High{" "}
                      <b style={{ color: "black" }}>
                        forward passes, Interceptions,{" "}
                      </b>
                      and{" "}
                      <b style={{ color: "black" }}>
                        passes to the final third.
                      </b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Elite defensive engagement:{" "}
                      </b>
                      Outstanding in defensive duels (+1.82) and high
                      interceptions (+1.31)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Physical attacking style:{" "}
                      </b>
                      Very high in{" "}
                      <b style={{ color: "black" }}>
                        defensive duels, offensive duels{" "}
                      </b>
                      (+1.78), and <b style={{ color: "black" }}>dribbles</b>{" "}
                      (+1.43)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Active disruption:</b> High
                      fouling rate (+1.35) and good ball recoveries (+0.88)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Direct play tendencies: </b>
                      Good in forward passes (+0.55) and aerial duels (+0.51)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 8 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Transition Speed - Accelerations (+1.09 z){" "}
                      </b>
                      Clear standout trait. Teams in this cluster heavily use
                      explosive movements to quickly move the ball up field, key
                      for counterattacking and fast breaks.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Progression via Movement:{" "}
                      </b>
                      Dribbles (+0.41 z) Indicates confidence in advancing the
                      ball individually, especially in transition scenarios or
                      isolated duels.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Combinational Play: </b>
                      Linkup Plays (+0.44 z) Shows fluency in short-passing
                      combinations, likely in the midfield or edge of the final
                      third.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Chance Creation: </b>Through
                      Passes (+0.39 z) Suggests vertical intent—trying to play
                      incisive balls behind defensive lines.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 6 && (
                <>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Highly aggressive defending:{" "}
                      </b>
                      Very high fouling (+1.53) and good defensive duels (+0.92)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Strong aerial presence: </b>
                      Good in aerial duels (+0.24) and aerial defence
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Effective disruption: </b>
                      Good interceptions (+0.67) and ball recoveries (+0.06)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 4 && (
                <>
                  <li>
                    <LabelText>
                      High{" "}
                      <b style={{ color: "black" }}>
                        xG, touches in box, shots,
                      </b>{" "}
                      and <b style={{ color: "black" }}>crosses.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Balanced metrics across the board, offensively tilted.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Exceptional in through passes (1.86), expected goals
                      (1.85), and shots (1.81)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Highest in linkup plays (1.73) and forward passes (1.70)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      High possession (445.14 passes per game)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Best xG ratio (1.69 for vs. 1.08 against)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 2 && (
                <>
                  <li>
                    <LabelText>
                      Outstanding in{" "}
                      <b style={{ color: "black" }}>
                        aerial duels, recoveries,{" "}
                      </b>
                      and <b style={{ color: "black" }}>defensive duels.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Strong in ball recoveries (1.74)</LabelText>
                  </li>
                  <li>
                    <LabelText>High pass length (1.68)</LabelText>
                  </li>
                  <li>
                    <LabelText>Extremely high in aerial duels (2.19)</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Good at interceptions (interceptions: 1.34)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Lower in overall number of passes (-0.91)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Decent attacking value in{" "}
                      <b style={{ color: "black" }}>
                        crosses, passes to final third,{" "}
                      </b>
                      and <b style={{ color: "black" }}>offensive duels.</b>
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 7 && (
                <>
                  <li>
                    <LabelText>
                      Moderately stable in{" "}
                      <b style={{ color: "black" }}>xG against</b> and{" "}
                      <b style={{ color: "black" }}> head shots,</b> suggesting
                      compact shape.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Balanced passing with average{" "}
                      <b style={{ color: "black" }}> pass volume</b> and{" "}
                      <b style={{ color: "black" }}>defensive coverage.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Balanced across most metrics:{" "}
                      </b>{" "}
                      Few extreme strengths or weaknesses.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Slight possession tendency:
                      </b>{" "}
                      Marginally above average in passes (+0.03)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Limited dynamism:</b> Poor
                      in accelerations (-1.03), dribbles (-0.95), and ball
                      recoveries (-0.85)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Passive approach:</b> Low in
                      fouls (-0.85), through passes (-0.90), and defensive duels
                      (-0.85)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 5 && (
                <>
                  <li>
                    <LabelText>
                      High{" "}
                      <b style={{ color: "black" }}>passes, pass length, </b>
                      and <b style={{ color: "black" }}> touches in the box.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low <b style={{ color: "black" }}>xG against, </b>
                      suggesting strong control of territory.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Strong possession control:{" "}
                      </b>
                      High passing volume (+1.14) and forward passing (+0.73)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Quality chance creation:</b>{" "}
                      Good xG (+0.95), shots (+0.72), and box touches (+1.25)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>Defensive caution: </b> Low
                      in fouls (-1.22) suggesting good technical ability and
                      limited defensive duels (-1.27)
                    </LabelText>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="team-archtype-info-content">
            <LabelText className="player-given-name">Weaknesses:</LabelText>
            <ul>
              {activeArchetypeID === 3 && (
                <>
                  <li>
                    <LabelText>
                      Poor in almost all creative and possession metrics,
                      including{" "}
                      <b style={{ color: "black" }}> passes, crosses, </b>and
                      <b style={{ color: "black" }}> duels.</b>
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 1 && (
                <>
                  <li>
                    <LabelText>
                      Slightly negative on{" "}
                      <b style={{ color: "black" }}> touches in box </b>and{" "}
                      <b style={{ color: "black" }}>xG conceded, </b>
                      indicating some defensive vulnerabilities.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 8 && (
                <>
                  <li>
                    <LabelText>
                      Aerial & Defensive Solidity Aerial Duels (–0.35 z)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>Ball Recoveries (–0.28 z)</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Interceptions (–0.13 z) Teams in this cluster are less
                      likely to dominate physically in duels or recover
                      possession frequently — indicating a preference for
                      structure over aggression.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Box Presence & Sustainment. Touches in Box (–0.13 z)
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Passes to Final Third (–0.09 z) While capable of reaching
                      advanced areas quickly, they don't sustain deep occupation
                      of the final third — more about fast execution than
                      extended build-up.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 6 && (
                <>
                  <li>
                    <LabelText>
                      Poor
                      <b style={{ color: "black" }}>
                        final third entries, through passes,{" "}
                      </b>
                      and <b style={{ color: "black" }}>xG creation.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low <b style={{ color: "black" }}> touches in box </b>and{" "}
                      <b style={{ color: "black" }}>crosses - </b> limited
                      attacking thrust.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Limited attacking threat:{" "}
                      </b>
                      Poor in shots (-0.96), touches in box (-1.07), and crosses
                      (-1.06)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 4 && (
                <>
                  <li>
                    <LabelText>
                      Slightly weak in{" "}
                      <b style={{ color: "black" }}>recoveries</b> and{" "}
                      <b style={{ color: "black" }}>defensive duels.</b>
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 2 && (
                <>
                  <li>
                    <LabelText>
                      Below-average{" "}
                      <b style={{ color: "black" }}>xG from shots</b> and{" "}
                      <b style={{ color: "black" }}>touches in box - </b>
                      lack of goal threat.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      <b style={{ color: "black" }}>
                        Poor possession metrics:{" "}
                      </b>
                      Low overall passes (-1.02) and forward passes (-1.48)
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 7 && (
                <>
                  <li>
                    <LabelText>
                      Low in <b style={{ color: "black" }}>pressing, duels, </b>
                      and <b style={{ color: "black" }}>chance creation.</b>
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Very little penetration via{" "}
                      <b style={{ color: "black" }}>through balls </b>or{" "}
                      <b style={{ color: "black" }}>touches in box.</b>
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 5 && (
                <>
                  <li>
                    <LabelText>
                      Low<b style={{ color: "black" }}> crosses, dribbles, </b>
                      and <b style={{ color: "black" }}>recoveries - </b>{" "}
                      possession without penetration.
                    </LabelText>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="team-archtype-info-content">
            <LabelText className="player-given-name">Tactical:</LabelText>
            <ul>
              {activeArchetypeID === 3 && (
                <>
                  <li>
                    <LabelText>
                      Likely a low-block, reactive team focused on compact
                      defence. Struggles in possession and buildup.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      These teams prioritize defensive solidity above all else.
                      They focus on denying quality chances to opponents and
                      maintaining their defensive shape. Their gameplay is
                      likely characterized by deep defensive blocks, limited
                      attacking ambition, and a focus on frustrating opponents.
                      A defensive, team that often plays under pressure.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 1 && (
                <>
                  <li>
                    <LabelText>
                      {" "}
                      This team archetype excels at aggressive pressing and
                      winning the ball through physical confrontations all over
                      the pitch. They're disruptive, combative, and relentless
                      in challenging opponents, making them difficult to play
                      against. Their high involvement in both defensive and
                      offensive duels suggests they excel in transition moments
                      and can quickly turn defence into attack.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 8 && (
                <>
                  <li>
                    <LabelText>
                      Quick defensive recovery → transition through attacking
                      midfielders and wingers.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 6 && (
                <>
                  <li>
                    <LabelText>4-4-2 or 3-5-2.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Emphasis on winning duels, disrupting rhythm, exploiting
                      set pieces.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      These teams focus on disrupting opponents through
                      aggressive challenges and tactical fouls. They're
                      physical, combative, and direct in their approach,
                      preferring to break up play rather than build
                      constructively. While they're effective at stopping
                      opponents in certain areas, they lack creativity and
                      attacking quality, suggesting teams that prioritize
                      results through pragmatism over entertainment.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 4 && (
                <>
                  <li>
                    <LabelText>4-3-3 or 3-2-2-3 (box midfield).</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Overloads in half-spaces, high positional discipline.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      These teams embody an attacking philosophy, focusing on
                      entertaining, possession-based football with high-quality
                      chance creation. Their technical abilities and offensive
                      metrics suggest teams at the upper tier of their leagues,
                      capable of dominating opponents through skill and
                      creativity. However, their commitment to attack comes at a
                      defensive cost, making them potentially vulnerable to
                      counter-attacks.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 2 && (
                <>
                  <li>
                    <LabelText>Strong midfield shielding.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      {" "}
                      Set-piece reliance and direct wing play.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 7 && (
                <>
                  <li>
                    <LabelText>4-2-3-1 or 4-1-4-1.</LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Low-to-mid block structure with safety-first possession
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      These teams adopt a conservative, risk-averse approach
                      with few distinguishing characteristics. They avoid
                      extremes in their playing style, preferring safety over
                      creativity or aggression. Their cautious approach suggests
                      teams that prioritize stability and organization,
                      potentially mid-table sides that focus on fundamentals
                      rather than specialized tactics.
                    </LabelText>
                  </li>
                </>
              )}
              {activeArchetypeID === 5 && (
                <>
                  <li>
                    <LabelText>
                      4-3-3 or 4-2-3-1 with focus on metronomic build-up.
                    </LabelText>
                  </li>
                  <li>
                    <LabelText>
                      Requires technical midfielders and progressive CBs. These
                      teams focus on controlled possession and methodical
                      build-up play. They create quality chances through patient
                      passing rather than high intensity pressing or physical
                      confrontations. Their style suggests technically
                      proficient teams that prioritize ball retention and
                      positional play, likely influenced by possession-based
                      tactical philosophies prevalent in modern football.
                    </LabelText>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="individuas-pitch-player-conatiner">
          <div className="typical-exmaples-container">
            <p>Typical examples</p>
            <div className="individual-typical-player-container">
              {teamArchtypeInfo?.map((example) => (
                <div className="individual-typical-player">
                  <img src={example?.logoURL} alt="player-image" />
                  <div>
                    <p className="typical-player-name">{example?.name}</p>
                    <p className="typical-player-club">
                      {example?.competitionName}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="typical-heat-signature-container">
            <p>Works well with...</p>
            <div>
              {worksWellWith?.map((work) => (
                <div style={{ backgroundColor: getArchetypeColorByValue(work?.score) }} className="work-archetype">
                  {work?.archetypeName}
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </TeamSelectionContainer>
    </Drawer>
  );
};

interface MFRoadMapDrawerProps {
  isRoadMapDrawerOpen: boolean;
  setIsRoadMapDrawerOpen: (value: boolean) => void;
}

export const MFRoadMapDrawer: React.FC<MFRoadMapDrawerProps> = ({
  isRoadMapDrawerOpen,
  setIsRoadMapDrawerOpen,
}) => {
  return (
    <Drawer
      PaperProps={{
        style: {
          left: "70px",
          backgroundColor: "transparent",
          backdropFilter: "blur(16px)",
          width: "470px",
          zIndex: "99999",
        },
      }}
      anchor="left"
      variant="persistent"
      open={isRoadMapDrawerOpen}
      onClose={() => {
        setIsRoadMapDrawerOpen(!isRoadMapDrawerOpen);
      }}
    >
      <TeamSelectionContainer>
        <TeamSelectionHeader>
          <TeamDrawerHeader style={{ lineHeight: "35px" }}>
            Machine Football feature roadmap
          </TeamDrawerHeader>
          <div className="header-buttons">
            <ForawrdBackwardButton
              onClick={(event) => {
                event?.stopPropagation();
                document
                  .querySelectorAll(".squad-pitch-player-card")
                  ?.forEach((card) => {
                    (card as HTMLElement).style.zIndex = "0";
                  });
                setIsRoadMapDrawerOpen(false);
              }}
            >
              <CloseIcon className="cta-btn-icons" />
            </ForawrdBackwardButton>
          </div>
        </TeamSelectionHeader>
        <div className="mf-roadmap-container">
          {/* <div style={{paddingTop:"16px",borderBottom:'1px solid #DADADA',paddingBottom:'16px'}}> */}

          <LabelText
            className="player-detail-given-name"
            style={{ marginTop: "16px" }}
          >
            Coming soon
          </LabelText>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Game models & squad playing styles
              </LabelText>
              <LabelText className="roadmap-text">
                A way to understand and evaluate how a team plays.
              </LabelText>
              <LabelText className="roadmap-text">
                <ul>
                  <li>what style they employ</li>
                  <li> how successful they are with it</li>
                  <li>
                    how much effort it’ll take to optimise it (what player roles
                    they’re missing etc.)
                  </li>
                  <li>
                    comparison to other teams playing that style (who’s doing it
                    well, what not to do etc)
                  </li>
                  <li>what other styles might better suit them</li>
                </ul>
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Squad depth & team make up
              </LabelText>
              <LabelText className="roadmap-text">
                A view on how well stocked a team is for each position on the
                pitch and a way to build a strategy for squad optimisation.
              </LabelText>
              <LabelText className="roadmap-text">
                <ul>
                  <li>what areas are they week in?</li>
                  <li>what players can be moved on?</li>
                  <li>when are contracts due to expire?</li>
                  <li>cdo they have youth players coming through?</li>
                </ul>
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                GBE calculator
              </LabelText>
              <LabelText className="roadmap-text">
                In order for payers to transfer to foreign countries, they need
                to meet certain conditions based on minutes played both for club
                and country, plus other criteria. This tool will make it easy to
                see what a player, agent and club/s need to do to in order for
                the player to be eligible for the move.
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">FFP modelling</LabelText>
              <LabelText className="roadmap-text">
                A means of seeing the effects a potential transfer will have on
                a club’s ability to meet FFP conditions, and what potential
                business they could do to ensure a transfer can go ahead without
                any rules being broken.
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Player loan valuation
              </LabelText>
              <LabelText className="roadmap-text">
                Search and evaluate clubs and squads for a potential move. Who
                needs a player the most and where will they have the most
                impact? How might it affect their career arc?
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          {/* </div> */}
          <LabelText className="player-detail-given-name">
            Planned for the future
          </LabelText>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Mobile and iPad compatability
              </LabelText>
              <LabelText className="roadmap-text">
                Essential for public consumption. At the moment this site’s only
                optimised for larger screens and we intend to rectify that asap.
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Multiple shortlists
              </LabelText>
              <LabelText className="roadmap-text">
                The ability to make a shortlist for each project you’re looking
                into. One for each position or player role you want to recruit
                for, or whatever you want really.
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
          <div className="roadmap-info-container">
            <div className="roadmap-info-content">
              <LabelText className="player-given-name">
                Sharable shortlists
              </LabelText>
              <LabelText className="roadmap-text">
                We want to make it easy for you to show people your shortlists
                in their live state and even make them collaborative so you can
                invite people to add to them.
              </LabelText>
            </div>
            <SecondaryButton iconType="hand" label="I WANT THIS" />
          </div>
        </div>
        <div className="roadmap-bottom-info">
          <div>
            <LabelText className="secondary-cta-text">
              We want to make this as useful to you as we can,
            </LabelText>
          </div>
          <div>
            <LabelText className="roadmap-text">
              so please feel free to send us any ideas you have via your MF
              Whatsapp channel.
            </LabelText>
          </div>
        </div>
      </TeamSelectionContainer>
    </Drawer>
  );
};
